import { render, staticRenderFns } from "./backHead.vue?vue&type=template&id=a5ef8812&scoped=true&"
import script from "./backHead.vue?vue&type=script&lang=js&"
export * from "./backHead.vue?vue&type=script&lang=js&"
import style0 from "./backHead.vue?vue&type=style&index=0&id=a5ef8812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ef8812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5ef8812')) {
      api.createRecord('a5ef8812', component.options)
    } else {
      api.reload('a5ef8812', component.options)
    }
    module.hot.accept("./backHead.vue?vue&type=template&id=a5ef8812&scoped=true&", function () {
      api.rerender('a5ef8812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/backHead.vue"
export default component.exports